<template>
    <div class="m_con">
        <div class="adv_bg" :class="{ noscroll: showMask }">
            <div class="adv_banner">
                <img src="../../img/hotline_bkg.png" />
            </div>
            <div class="adv_1" v-loading="loading">
                <!-- <div class="address_wrap">
        <el-cascader
          class="cityChoice"
          ref="myCascader"
          v-model="selectAddress"
          placeholder="请选择地区"
          :options="data"
          @change="handleSearch"
        ></el-cascader>
        <p
          class="searchBtn"
          @click="handleSearch"
        >切换</p>
      </div> -->
                <div class="adv_1_2" v-if="Object.keys(companyDetail).length > 0">
                    <div class="company">
                        <p>{{ companyDetail.name }}</p>
                        <p class="searchBtn" @click="handleShowSearch">切换</p>
                    </div>
                    <p class="callBtn" @click="makePhoneCall(companyDetail.kf_tel)">点击拨打：{{ companyDetail.kf_tel }}</p>
                </div>
                <div class="adv_1_2" v-else>
                    <div class="company">
                        <p style="flex: 1;">{{ message }}</p>
                        <p class="searchBtn" @click="handleShowSearch">切换</p>
                    </div>
                </div>
            </div>
            <div class="adv_1">
                <div class="adv_ti">
                    <span>· 公司简介 ·</span>
                </div>
                <div class="adv_1_1">
                    洪师傅代驾成立于2015年，成立以来始终把服务顾客，留住顾客，赢得顾客当成宗旨坚持执行到位，目前覆盖600多个城市，同时上线达到60000余名的司机覆盖率，正常到达速度10分钟内，同时还为顾客提供5大保障:
                </div>
                <div class>
                    <img src="../../img/hsfimg10.jpg" />
                </div>
            </div>
        </div>
        <div v-show="showMask" class="mask" @click="handleShowSearch" />
        <div v-show="showMask" class="m-layer">
            <div class="content">
                <p style="display:inline;">地区：</p>
                <el-cascader
                    class="cityChoice"
                    ref="myCascader"
                    v-model="selectAddress"
                    placeholder="请选择地区"
                    clearable
                    :options="data"
                    @change="handleSearch"
                ></el-cascader>
            </div>
        </div>
    </div>
</template>
<script>
import { config } from '../../utils/config'
export default {
    name: 'NewHotLine',
    components: {},
    data() {
        return {
            data: [],
            selectAddress: [],
            loading: false,
            listQuery: {
                service_id: this.$route.query.service_id,
                lat: '',
                lng: ''
            },
            companyDetail: {},
            message: '',
            showMask: false
        }
    },
    mounted() {
        this.getCity()
        this.getMyLocation()
    },
    methods: {
        getCity() {
            this.$axios.get('/api/wechat/region/list').then((res) => {
                this.data = res.data
            })
        },
        getMyLocation() {
            // 定位获得当前位置信息
            this.loading = true
            var geolocation = new window.qq.maps.Geolocation(config[config.env].baiduKey, '洪师傅-h5')
            geolocation.getLocation(this.showPosition, this.showErr) // 定位后回调（成功，失败）
        },
        showPosition(position) {
            console.log('定位成功', position)
            this.listQuery.lat = position.lat
            this.listQuery.lng = position.lng
            this.getCompanyInfo()
        },
        showErr() {
            console.log('定位失败')
            this.getMyLocation() // 定位失败再请求定位，测试使用
        },
        getCompanyInfo() {
            // 定位获取公司信息
            this.$axios.get('/api/wechat/info/companyinfo', this.listQuery).then((res) => {
                this.loading = false
                if (res.code === 200) {
                    this.companyDetail = res.data
                }
            })
        },
        handleShowSearch() {
            this.showMask = !this.showMask
        },
        handleSearch() {
            // 获取地区公司信息
            console.log('selectAddress', this.selectAddress)
            this.showMask = false
            this.$axios
                .get('/api/wechat/region/company', {
                    id: this.selectAddress[2]
                })
                .then((res) => {
                    console.log('res', res)
                    if (res.code === 200) {
                        this.companyDetail = res.data[0]
                    } else if (res.code === 422) {
                        this.companyDetail = {}
                        this.message = res.message
                    }
                })
        },
        makePhoneCall(tel) {
            console.log('tel', tel)
            window.location.href = `tel:${tel}`
        }
    }
}
</script>
<style lang="less">
.adv_bg {
    background: #ec3a2d;
    padding-bottom: 2px;
}
.adv_1 {
    position: relative;
    margin: 0 0.6rem;
    border-radius: 0.7rem; /* 11px*/
    background-color: #fff;
    padding: 2.05rem 1.667rem; /* 37px  30px*/
    font-size: 0.8rem; /* 14px  */
    text-align: left;
    margin-bottom: 30px;
}
.adv_ti {
    font-size: 1.2rem;
    background: url(../../img/hsfimg9_1.png);
    background-repeat: no-repeat;
    background-size: 100%;
    width: 384px;
    height: 72px;
    margin: 0 auto;
    text-align: center;
    color: #fff;
    display: flex;
    justify-content: center;
    font-weight: bold;
    letter-spacing: 0.25rem;
}
.adv_ti span {
    align-self: center;
}
.adv_1_1 {
    padding: 1.7rem 1.9rem;
    line-height: 1.8;
    border-radius: 0.388rem;
    border: solid 1px rgba(238, 238, 238, 0.8);
    border-bottom-color: #ff9100;
    border-right-color: #ff9100;
    position: relative;
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
    font-size: 24px;
}
.adv_1_2 {
    line-height: 1.8;
    border-radius: 0.388rem;
    border: solid 1px rgba(238, 238, 238, 0.8);
    border-bottom-color: #ff9100;
    border-right-color: #ff9100;
    position: relative;
    margin-top: 1rem;
    font-size: 24px;
}
.adv_1 .company {
    padding: 20px 0;
    display: flex;
    text-align: center;
    font-size: 1.8rem;
    font-weight: bold;
    margin: 0 auto;
    justify-content: center;
    align-items: center;
    position: relative;
}
.adv_1 .callBtn {
    margin: 0.625rem auto; // 27px auto 10px;
    text-align: center;
    background: -moz-linear-gradient(bottom, #fadb4b, #f8cb47);
    background: -webkit-linear-gradient(bottom, #fadb4b, #f8cb47);
    background: linear-gradient(to bottom, #fadb4b, #f8cb47);
    width: 16rem; //320px;
    height: 3.75rem; // 60px;
    line-height: 3.75rem; //  60px;
    border-radius: 1.875rem; // 30px
    font-size: 1.1rem; // 22px
    color: #333333;
}
.address_wrap {
    padding: 0 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.cityChoice {
    flex: 1;
    border-radius: 30px;
}
.searchBtn {
    position: absolute;
    right: 10px;
    top: -37px;
    margin-left: 30px;
    width: 112px;
    height: 60px;
    line-height: 60px;
    background: -moz-linear-gradient(bottom, #ee7d55, #ec4230);
    background: -webkit-linear-gradient(bottom, #ee7d55, #ec4230);
    background: linear-gradient(to bottom, #ee7d55, #ec4230);
    font-size: 24px;
    text-align: center;
    border-radius: 30px;
    color: #fff;
}
.el-input__inner {
    text-align: left;
    height: 70px;
    line-height: 70px;
    font-size: 32px !important;
    padding: 0 30px;
}
.el-cascader__dropdown {
    width: 96%;
    left: 2% !important;
}
.el-cascader-menu {
    width: 33.33%;
}
.el-cascader-panel {
    font-size: 32px !important;
}
.el-cascader-node {
    height: 80px;
    line-height: 80px;
}
.el-cascader-menu__wrap {
    height: 400px;
}
.el-select-dropdown__item {
    height: 60px;
    line-height: 60px;
    font-size: 32px !important;
}
.mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    z-index: 100;
}
.m-layer {
    position: fixed;
    top: 40%;
    left: 50%;
    width: 680px;
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    border-radius: 20px;
    z-index: 101;
    .content {
        padding: 57px 40px;
        .form_val {
            padding: 0;
            .inputcls {
                flex: 3;
            }
            .img_captcha {
                flex: 2;
                margin-left: 20px;
                width: 200px;
                height: 90px;
            }
        }
    }
    .submit {
        margin-bottom: 40px;
    }
}
.noscroll {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/hotline/newHotLine.vue